import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";

import AsideContacts from "../../components/AsideContacts";
import AsideNewFeed from "../../components/AsideNewFeed";

import PendingCreditz from "../../components/PendingCreditz";
import AcceptedCreditz from "../../components/AcceptedCreditz";
import SentCreditz from "../../components/SentCreditz";
import { database } from "../../firebase";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Loader from "../../components/Loader";

import "./creditz.css";

function Creditz() {

  const[dummystate,SetDummyState]=useState(false);
    const [accepted, setAccepted] = useState([]);


    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
      }));
    
      const [pending, setPending] = useState([]);
      function getUserData(uid) {
        return new Promise((resolve, reject) => {
          return database.ref("users/" + uid).once("value", (snap) => {
            resolve(snap.val());
          });
        });
      }
    
      function getCreditzData(credid) {
        return new Promise((resolve, reject) => {
          return database.ref("creditz/" + credid).once("value", (snap) => {
            resolve(snap.val());
          });
        });
      }
      function pendingCreditz() {
        return database
          .ref(`/user-creditz/`)
          .once("value")
          .then(async (snapshot) => {

            const creditRequests = [];
            const response = [];
            snapshot.forEach((childSnapshot) => {
              if (Object.keys(childSnapshot.val()).includes(currentUser.uid)) {
                creditRequests.push(childSnapshot.val());
              }
            });
    
            const pendingRequests = creditRequests.map((req) => {
                const obj = Object.values(req)[0];
                if (obj.status == "Pending "){
                    return obj
                }
            }).filter(e => e)
              var newRes = await Promise.all(
              pendingRequests.map(async (user) => {
                const Data = await getUserData(user.uid);
                const Creddata = await getCreditzData(user.credid);
    
                return { ...pendingRequests, user_details: Data, Creditz: Creddata };
              })
            );
            setPending(newRes);
          });
      }
      
      
      useEffect(() => {
        pendingCreditz();
      }, []);
  document.title = "Creditz";
  return (
    <>
      {/* Left Aside */}
      <AsideNewFeed></AsideNewFeed>
      <section className="main-content">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-3">
              <div className="card border-0 rounded-xl shadow-xs overflow-hidden mb-3">
                <div className="card-header d-flex align-items-center bg-primary px-4 py-2 fw-bold text-white">
                  Creditz
                  <Link
                    to="/AddCreditz"
                    role="button"
                    className="btn btn-light fw-semibold text-primary ms-auto px-3"
                  >
                    Add Creditz
                  </Link>
                </div>
                <ul
                  className="nav nav-tabs profile-tab border-0 ps-4"
                  role="tablist"
                >
                  <li className="list-inline-item me-5">
                    <Link
                      to="#receivedbox"
                      data-bs-toggle="tab"
                      className="active"
                    >
                      Received
                    </Link>
                  </li>
                  <li className="list-inline-item me-5">
                    <Link to="#sentbox" data-bs-toggle="tab">
                      Sent
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="tab-content">
                <div className="tab-pane fade show active" id="receivedbox">
                  <div className="card border-0 rounded-xl shadow-xs">
                    <div className="card-body p-3 p-md-4">
                      <h5 className="fw-semibold mb-3">
                        Pending Creditz
                      </h5>
                      <PendingCreditz dummystate={dummystate}/>
                      
                      {/* <h5 className="fw-semibold my-3">Accepted Creditz</h5>
                      <AcceptedCreditz dummystate={dummystate}/> */}
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="sentbox">
                  <div className="card border-0 rounded-xl shadow-xs">
                    <div className="card-body p-3 p-md-4">
                      <SentCreditz></SentCreditz>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Right Aside */}
      <AsideContacts></AsideContacts>
    </>
  );
}

export default withRouter(Creditz);
